var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['easyscreen-checkbox', `easyscreen-checkbox_design-${ _vm.design }`],on:{"click":(event) => _vm.$emit('input', !this.checked)}},[(_vm.checked)?_c('i',{staticClass:"easyscreen-checkbox--check-mark fa fa-check"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }